export default {
    title: 'Unterschrift',
    description: 'Mit deiner Unterschrift bestätigst du die Richtigkeit und Vollständigkeit der Angaben.',
    saveSuccess: 'Unterschrift wurde erfolgreich gespeichert.',
    invalidRoute: 'Ungültiger Link',
    isSigned: 'Unterschrift existiert bereits.'
}